export default "__VITE_ASSET__DD8jilUe__"